// extracted by mini-css-extract-plugin
module.exports = {"otpContainer":"GlobalOTP-module--otpContainer--2bLZ3","otpInput":"GlobalOTP-module--otpInput--MEPdN"};